<template>
  <section class="sign-container">
    <b-tooltip
      v-if="processFileSignCount(DOC_SIGN.SIGNED)"
      :type="isContrast ? 'is-blue-oil' : 'is-white'"
      multilined
      :always="showTooltip[DOC_SIGN.SIGNED]"
      size="is-large"
      class="list-sign"
      :position="tooltipPosition"
      appendToBody
    >
      <div
        data-cy="SIGNED_BUTTON"
        @mouseover="setShowTooltip(DOC_SIGN.SIGNED, true)"
        @mousemove="setShowTooltip(DOC_SIGN.SIGNED, false)"
      >
        <b-icon
          icon="checkbox-marked-circle"
          type="is-primary"
          size="is-small"
        />
      </div>
      <template v-slot:content>
        <section
          class="container-new"
          @mouseout="setShowTooltip(DOC_SIGN.SIGNED, false)"
          @mousemove="setShowTooltip(DOC_SIGN.SIGNED, true)"
        >
          <span
            class="has-text-weight-semibold"
            :class="{ 'has-text-white': isContrast }"
            >{{ General.SIGNATURES_MADE }}</span
          >
          <div
            v-for="(item, index) in processFileSign(DOC_SIGN.SIGNED)"
            :key="item.user_id"
            :class="item.status.toLowerCase()"
          >
            <br />
            <div class="spacing-mr-5"><div></div></div>
            <span
              class="flex-1 has-text-left"
              :class="{ 'has-text-white': isContrast }"
            >
              {{
                `${item.user_name} - ${General.ASSIGN_STATE[item.status]}${
                  processFileSignCount(DOC_SIGN.SIGNED) > 4 && index == 3
                    ? " " + General.TEXTS.AND_OTHERS
                    : ""
                }${
                  index == processFileSign(DOC_SIGN.SIGNED).length - 1
                    ? "."
                    : ""
                }`
              }}
            </span>
          </div>
        </section>
      </template>
    </b-tooltip>

    <b-tooltip
      v-if="processFileSignCount(DOC_SIGN.PENDING)"
      :type="isContrast ? 'is-blue-oil' : 'is-white'"
      multilined
      :always="showTooltip[DOC_SIGN.PENDING]"
      class="list-sign"
      size="is-large"
      :position="tooltipPosition"
      appendToBody
    >
      <div
        @mouseover="setShowTooltip(DOC_SIGN.PENDING, true)"
        @mousemove="setShowTooltip(DOC_SIGN.PENDING, false)"
      >
        <b-icon icon="alert-circle" type="is-pending" size="is-small" />
      </div>
      <template v-slot:content>
        <section
          class="container-new"
          @mouseout="setShowTooltip(DOC_SIGN.PENDING, false)"
          @mousemove="setShowTooltip(DOC_SIGN.PENDING, true)"
        >
          <span
            class="has-text-weight-semibold"
            :class="{ 'has-text-white': isContrast }"
            >{{ General.SIGNATURES_PENDING }}</span
          >
          <div
            v-for="(signature, index) in processFileSign(DOC_SIGN.PENDING)"
            :key="signature.user_id"
            :class="signature.status.toLowerCase()"
          >
            <br />
            <div class="spacing-mr-5"><div></div></div>
            <span
              class="flex-1 has-text-left"
              :class="{ 'has-text-white': isContrast }"
            >
              {{
                `${signature.user_name} - ${
                  General.ASSIGN_STATE[signature.status]
                }${
                  processFileSignCount(DOC_SIGN.PENDING) > 4 && index == 3
                    ? " " + General.TEXTS.AND_OTHERS
                    : ""
                }${
                  index == processFileSign(DOC_SIGN.PENDING).length - 1
                    ? "."
                    : ""
                }`
              }}
            </span>
          </div>
        </section>
      </template>
    </b-tooltip>

    <b-tooltip
      v-if="processFileSignCount(DOC_SIGN.REFUSED)"
      :type="isContrast ? 'is-blue-oil' : 'is-white'"
      multilined
      :always="showTooltip[DOC_SIGN.REFUSED]"
      class="list-sign"
      size="is-large"
      :position="tooltipPosition"
      appendToBody
    >
      <div
        @mouseover="setShowTooltip(DOC_SIGN.REFUSED, true)"
        @mousemove="setShowTooltip(DOC_SIGN.REFUSED, false)"
      >
        <b-icon icon="close-circle" type="is-refused" size="is-small" />
      </div>
      <template v-slot:content>
        <section
          class="container-new"
          @mouseout="setShowTooltip(DOC_SIGN.REFUSED, false)"
          @mousemove="setShowTooltip(DOC_SIGN.REFUSED, true)"
        >
          <span
            class="has-text-weight-semibold"
            :class="{ 'has-text-white': isContrast }"
            >{{ General.SIGNATURES_REFUSED }}</span
          >
          <div
            v-for="(item, index) in processFileSign(DOC_SIGN.REFUSED)"
            :key="item.user_id"
            :class="item.status.toLowerCase()"
          >
            <br />
            <div class="spacing-mr-5"><div></div></div>
            <span
              class="flex-1 has-text-left"
              :class="{ 'has-text-white': isContrast }"
            >
              {{
                `${item.user_name} - ${General.ASSIGN_STATE[item.status]}${
                  processFileSignCount(DOC_SIGN.REFUSED) > 4 && index == 3
                    ? " " + General.TEXTS.AND_OTHERS
                    : ""
                }${
                  index == processFileSign(DOC_SIGN.REFUSED).length - 1
                    ? "."
                    : ""
                }`
              }}
            </span>
          </div>
        </section>
      </template>
    </b-tooltip>
  </section>
</template>

<script>
import { DOC_SIGNATURES_STATUS as DOC_SIGN } from "@/utils/enumerate";
import { General } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "SubscriptionHistoryOnlyView",
  props: {
    signHistory: {
      type: Array,
      default: () => []
    },
    tooltipPosition: {
      type: String,
      default: "is-top"
    }
  },
  data() {
    return {
      General,
      DOC_SIGN,
      showTooltip: {
        REFUSED: false,
        PENDING: false,
        SIGNED: false
      }
    };
  },
  computed: {
    ...mapGetters(["isContrast", "isMobile"])
  },
  methods: {
    signatureHistoryType(type) {
      return this.signHistory.length
        ? this.signHistory.filter(
            signature => signature.status === type && !signature.only_historical
          )
        : [];
    },

    processFileSignCount(type) {
      return this.signatureHistoryType(type).length;
    },

    processFileSign(type) {
      return this.signatureHistoryType(type).slice(0, 4);
    },

    setShowTooltip(type, state) {
      this.showTooltip[type] = state;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.sign-container {
  min-width: 1vw;
  @media screen and (max-width: 768px) {
    min-width: 10vw;
  }
  width: 20px;
}

.container-attached-doc {
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: #ccc;
}

.list-sign div {
  display: flex;
  align-items: center;
  margin: 2px 5px;
}

.list-sign div.pending > div > div,
.list-sign div.signed > div > div,
.list-sign div.refused > div > div,
.circle {
  border-radius: 50%;
  height: 8px;
  width: 8px;
  margin-right: 5px;
}

.list-sign div.pending > div > div,
.circle.pending {
  background-color: $pending-color;
}

.list-sign div.signed > div > div,
.circle.signed {
  background-color: $primary;
}

.list-sign div.refused > div > div,
.circle.refused {
  background-color: $refused-color;
}

.circle {
  height: 12px;
  width: 12px;
  cursor: pointer;
}

.list-sign .tooltip-content {
  background-color: red !important;
  color: blue !important;
}

.container-new {
  text-align: left;
  color: #000;
  font-weight: 300;
}

.handler {
  cursor: move;
  opacity: 0;
}

.container-attached-doc:hover .handler {
  opacity: 1;
}

.tooltip-container {
  display: flex;
  justify-content: flex-start;
  margin: auto;
}
</style>
